export default __webpack_public_path__ + "static/media/html5-logo.4b291eb9.svg";